import { Component, HostListener, Input, OnDestroy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf } from "@angular/common";

@Component({
  selector: "auto-reload",
  templateUrl: "./auto-reload.component.html",
  styleUrls: ["./auto-reload.component.scss"],
  imports: [TranslateModule, NgIf],
})
export class AutoReloadComponent implements OnDestroy {
  private interval: ReturnType<typeof setInterval>;
  @Input()
  public url: string = "/index.html";
  public isUpdateAvailable: boolean = false;

  @HostListener("click")
  public click(): void {
    window.location.reload();
  }

  public ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
